import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AuthApi} from "../../../../../const/admin.url";
import {encrypt} from "../../../../../common/general-functions";
import {map} from "rxjs/operators";
import {TokenStorageService} from "./token-storage.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    constructor(
        private http: HttpClient,
        private tokenService: TokenStorageService
    ) { }

    autoLogin(token: string){
        this.tokenService.saveToken(token);
        return this.http.get<any>(AuthApi.profile).pipe(map((response) => {
            if (response.responseData.user) {
                response.responseData.user.profile = response.responseData.assets_url + response.responseData.user.profile;
                this.tokenService.saveUser(response.responseData.user);
            }
            return response;
        }));
    }

    loginAPI(body?: any){
        let req:any = {};
        // req.email = encrypt(body.email);
        // req.password = encrypt(body.password);

        return this.http.post<any>(AuthApi.login, body).pipe(map((response) => {
            if(response.data){

                // response.data.profile = response.data.assets_url + response.data.profile;
                this.tokenService.saveToken(response.data.token);
                this.tokenService.saveUser(response.data);
            }
            return response;
        }));
    }

    forgotPasswordAPI(body? :any){
        let req:any = {};
        req.email = body.email;
        return this.http.post<any>(AuthApi.forgotPassword, req);
    }

    signOut(){
        return this.http.get<any>(AuthApi.logout, {}).pipe(map((response) => {
            if(response.status){
                this.tokenService.signOut();
            }
            return response;
        }))
    }

    changePassword(body?: any){
        let req:any = {};
        req.oldPassword = body.old_password;
        req.password = body.new_password;

        return this.http.put<any>(AuthApi.changePassword, req);
    }

    resetPassword(body?: any){
      return this.http.post<any>(AuthApi.resetPassword, body);
    }

    updateUserInfo(body?: any){
        return this.http.post<any>(AuthApi.updateUserInfo, body).pipe(map((response) => {
            if(response.responseData.user){
                if(!response.responseData.user.profile.includes('http')){
                    response.responseData.user.profile =  response.responseData.assets_url + response.responseData.user.profile;
                }
                this.tokenService.saveUser(response.responseData.user);
            }
            return response;
        }));
    }
}
